import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { WalletContext } from '../context/WalletContext'; // Import WalletContext
import './Header.css'; // Include your custom CSS file

const Header = () => {
  const { account } = useContext(WalletContext); // Get the account from context
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevState) => !prevState);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header-wrap style1">
      <div className="container">
        <nav className="navbar navbar-expand-md navbar-light">
          {/* Logo */}
          <Link className="navbar-brand" to="/" onClick={closeMobileMenu}>
            <img src="assets/img/resources/logo-white.png" alt="logo" width={180} />
          </Link>

          {/* Mobile Toggle Button */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMobileMenu}
            aria-controls="navbarSupportedContent"
            aria-expanded={isMobileMenuOpen ? 'true' : 'false'}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" style={{ color: 'yellow' }}></span>
          </button>

          {/* Dynamic Classes for Menu */}
          <div
            className={`navbar-collapse main-menu-wrap ${isMobileMenuOpen ? 'show open' : 'collapse'}`}
            id="navbarSupportedContent"
          >
            <div className="menu-close d-lg-none" onClick={toggleMobileMenu}>
              <button className="close-btn">
                <i className="ri-close-line"></i>
              </button>
            </div>

            {/* Menu Items */}
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link to="/" className="nav-link" onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              {/* Mobile View Buttons */}
              <li className="nav-item d-lg-none">
                <Link to="/connect-wallet" className="btn style1" onClick={closeMobileMenu}>
                  {account ? 'Connected' : 'Connect Wallet'}
                </Link>
              </li>
              <li className="nav-item d-lg-none">
                <Link to="/swaptoken" className="btn style1 btn-style-2" onClick={closeMobileMenu}>
                  Swap Token
                </Link>
              </li>
            </ul>

            {/* Desktop View Buttons (Hidden on Mobile) */}
            <div className="others-options md-none gap-2 d-lg-flex d-none">
              <div className="header-btn">
                <Link to="/connect-wallet" className="btn style1" onClick={closeMobileMenu}>
                  {account ? 'Connected' : 'Connect Wallet'}
                </Link>
              </div>
              <div className="header-btn">
                <Link to="/swaptoken" className="btn style1 btn-style-2" onClick={closeMobileMenu}>
                  Swap Token
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
